import React from 'react'
import { Icons } from '@pankod/refine-antd'

import ActivityGroupDrawer, {
  useActivityGroupDrawer,
} from '../../../../program-setup/blocks/activity-group/ActivityGroupDrawer'
import ModulDrawer, {
  useModulDrawer,
} from '../../../../program-setup/blocks/program-module/ModulDrawer'
import PaketModulDrawer, {
  usePaketModulConfigDrawer,
} from '../../../../program-setup/blocks/paket-modul/PaketModulDrawer'
import PresensiDrawer, {
  usePresensiDrawer,
} from '../../../../program-setup/blocks/presensi/PresensiDrawer'
import { Highlighter } from '../../utils'

import type {
  TConfigurationSection,
  TConfigurationSectionContext,
} from '../types'

export const useModuleConfiguration = ({
  program,
  programId,
  runAndClose,
  search,
}: TConfigurationSectionContext): TConfigurationSection => {
  const { show: showModulSetup, ...modulDrawerProps } = useModulDrawer()
  const { show: showPresensi, ...presensiDrawerProps } = usePresensiDrawer()
  const { show: showPaketModulConfigDrawer, ...paketModulDrawerProps } =
    usePaketModulConfigDrawer()
  const { show: showActivityGroupList, ...activityGroupDrawerProps } =
    useActivityGroupDrawer()

  return {
    menuItems: [
      {
        type: 'group',
        label: <Highlighter search={search} text="Program Modul" />,
        key: 'Program Modul',
        children: [
          {
            icon: <Icons.BookOutlined />,
            label: <Highlighter search={search} text="Pengaturan Modul" />,
            key: 'Pengaturan Modul',
            onClick: () =>
              runAndClose(() => showModulSetup(programId, program?.name!)),
          },
          {
            icon: <Icons.BuildFilled />,
            label: <Highlighter search={search} text="Kelola Paket Modul" />,
            key: 'Kelola Paket Modul',
            onClick: () =>
              runAndClose(() => showPaketModulConfigDrawer(programId)),
          },
          {
            icon: <Icons.AppstoreOutlined />,
            label: (
              <Highlighter search={search} text="Kelola Kelompok Aktivitas" />
            ),
            key: 'Kelola Kelompok Aktivitas',
            onClick: () =>
              runAndClose(() =>
                showActivityGroupList(programId, program?.status),
              ),
          },
          {
            icon: <Icons.CarryOutOutlined />,
            label: <Highlighter search={search} text="Pengaturan Presensi" />,
            key: 'Pengaturan Presensi',
            onClick: () =>
              runAndClose(() => showPresensi(programId, program?.name!)),
          },
        ],
      },
    ],
    overlays: (
      <>
        <ModulDrawer {...modulDrawerProps} programStatus={program?.status} />
        <PresensiDrawer
          {...presensiDrawerProps}
          programStatus={program?.status}
        />
        <PaketModulDrawer {...paketModulDrawerProps} />
        <ActivityGroupDrawer {...activityGroupDrawerProps} />
      </>
    ),
  }
}
